<template>
  <div class="bk-modal-wrapper">
    <modal
      :title="$t('ui.segments.businesskits_modal.title')"
      :open="sendBusinessKitModalOpen"
      @save="sendBusinessKits()"
      :saveText="$t('ui.segments.businesskits_modal.send')"
      @cancel="closeSendBusinessKitModalOpen()"
      class="businesskit-modal"
      :saveDisabled="!(selectedBusinessKitId && emailTemplatesChecked)"
    >
      <template v-slot:header>
        <div class="businesskit-header-modal">
          <img src="../../../../assets/businesskits/businesskit-header-modal.png">
        </div>
      </template>

      <p class="title-subtext">
        {{$t('ui.segments.business_kit.subtext')}}
      </p>

      <div v-if="businessKits.length > 0">
        <field
          class="businesskit-select"
          model="business_kit"
          name="select"
          :params="{no_i18n: true}"
          type="select"
          :collection="businessKits"
          :value="selectedBusinessKitId"
          @input="selectBusinessKit"
          :autofocus="true"
        />

        <div class="preview-bk is-margin-top-10">
          <a :href="this.selectedBusinessKitUrl" target="_blank" rel="noopener noreferrer" class="link" v-if="selectedBusinessKitUrl">
            {{ $t('ui.segments.business_kit.preview') }}
          </a>
        </div>
      </div>
      <div v-else>
        {{$t('ui.pages.lead-no-businesskit')}}
      </div>

      <div class="segment-info">
        <h5>{{$t('ui.segments.business_kit.segment_title')}}:</h5>

        <h4 class="info-text">
          {{ this.segment && this.segment.name }} ({{ contactsCount }} {{$t('ui.segments.business_kit.contacts')}})
        </h4>
      </div>

      <div class="email-template-info">
        <p class="info-text">
          <q-checkbox color="primary" v-model="emailTemplatesChecked" :label="$t('ui.segments.business_kit.email_templates_confirmation')"/>
        </p>
      </div>
    </modal>
  </div>
</template>

<script>
import ContactsApi from "@/api/Contacts";
import BusinessKitApi from "@/api/BusinessKit"
import Modal from '@/components/helpers/Layout/NewModal'
import Field from '@/components/helpers/DataInput/Field'

export default {
  components: { Modal, Field },
  props: {
    segment: {
      type: Object,
      default: {}
    },
    sendBusinessKitModalOpen: {
      type: Boolean,
      default: false
    },
    contactIds: {
      type: Array,
      default: []
    },
    totalTableCount: {
      type: Number,
      default: 0,
    }
  },
  data() {
    return {
      businessKits: [],
      selectedBusinessKitId: null,
      selectedBusinessKitUrl: '',
      emailTemplatesChecked: false,
    };
  },
  async mounted() {
    this.retrieveBusinessKits();
  },
  computed: {
    contactsCount() {
      if (this.contactIds.length) {
        return this.contactIds.length
      }

      return this.totalTableCount;
    }
  },
  methods: {
    selectBusinessKit(val){
      this.selectedBusinessKitId = val

      let selectedBusinessKit = this.businessKits.find((bk) => {
        return bk.value == val;
      });

      if (selectedBusinessKit) {
        this.selectedBusinessKitUrl = selectedBusinessKit.url;
      }
    },
    retrieveBusinessKits(){
      let businessKitApi = new BusinessKitApi()

      businessKitApi.all({disable_pagination: 'true'}).then(({resources}) => {
        var businessKits = []

        resources.forEach((bk) => {
          businessKits.push({
            "name": bk.name,
            "value": bk.id,
            "url": bk.preview_url
          })
        })

        this.businessKits = businessKits
      })
    },
    closeSendBusinessKitModalOpen() {
      this.$emit('closeBusinessKitModal');
    },
    async sendBusinessKits() {
      let contactsApi = new ContactsApi();
      let response = await contactsApi.sendBusinessKits({
        businessKitId: this.selectedBusinessKitId,
        projectName: this.segment.name,
        segmentId: this.segment.id,
        organizationId: this.segment.organization.id,
        contactIds: this.contactIds,
      })

      if (response.status == 204) {
        this.closeSendBusinessKitModalOpen();

        this.$store.commit("SET_NOTIFICATION", {
          title: "ui.segments.business_kit.success",
          type: "success"
        });
      } else {
        this.closeSendBusinessKitModalOpen();

        this.$store.commit("SET_NOTIFICATION", {
          title: "ui.segments.business_kit.error",
          type: "error"
        });
      }
    },
  }
}
</script>

<style lang="sass">
.bk-modal-wrapper
  .businesskit-modal
    .modal-wrapper
      max-width: 480px
      max-height: 100vh
      .modal-inner
        .modal-component
          padding: 30px 40px 30px 40px
      .preview-bk
        margin-left: 5px

        .link
          cursor: pointer

      .businesskit-select select
        margin-bottom: 0

      .segment-info
        margin-top: 20px
        h5
          color: $ink-light
          margin-bottom: 5px
          margin-top: 0

      .email-template-info
        margin-top: 20px
        p.info-text
          color: $ink-dark
          .q-option
            span.q-option-label
              margin-left: 15px
      .title-subtext
        color: $ink-light

      h4.modal-title
        padding-bottom: 4px !important
        font-size: 26px !important
        line-height: 32px !important

      .businesskit-header-modal
        max-width: 480px
        img
          border-top-left-radius: 5px
          border-top-right-radius: 5px
          width: 100%
  @media(max-width: 576px)
    .modal-wrapper
      min-width: 320px
      width: inherit
</style>



// WEBPACK FOOTER //
// BusinessKitModal.vue?7ed4020a